import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1cdfbd64")

_pushScopeId("data-v-1cdfbd64")
const _hoisted_1 = {
  id: "dialogConfirm",
  class: "fixed z-1 inset-0 overflow-y-auto",
  "data-aos": "zoom-in-up",
  "data-aos-anchor": "dialogConfirm"
}
const _hoisted_2 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "absolute z-0 inset-0 backdrop-filter backdrop-blur-xl" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", {
  "aria-hidden": "true",
  class: "hidden sm:inline-block sm:align-middle sm:h-screen"
}, "​", -1)
const _hoisted_5 = {
  "aria-labelledby": "modal-headline",
  "aria-modal": "true",
  class: "z-0 inline-block align-bottom bg-white dark:bg-gray-900 rounded-3xl text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full",
  role: "dialog",
  style: {"width":"-moz-available"}
}
const _hoisted_6 = { class: "float-right -mr-6 -mt-1" }
const _hoisted_7 = { class: " bg-white dark:bg-gray-900  rounded-3xl px-4 pt-5 pb-2 sm:p-6 sm:pb-0" }
const _hoisted_8 = { class: "mt-3 text-center sm:mt-0 sm:ml-4" }
const _hoisted_9 = {
  id: "modal-headline",
  class: "text-lg leading-6 font-medium text-gray-900 dark:text-gray-300"
}
const _hoisted_10 = { class: "mt-2 mb-4" }
const _hoisted_11 = { class: "text-sm text-gray-900 dark:text-gray-300" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "sm:flex sm:items-start" }, null, -1)
const _hoisted_13 = { class: "mt-0 sm:justify-between px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_btn_close = _resolveComponent("btn-close")
  const _component_rating_icons = _resolveComponent("rating-icons")
  const _component_input_area = _resolveComponent("input-area")
  const _component_default_button = _resolveComponent("default-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showButton === true)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDialog && _ctx.toggleDialog(...args)))
        }, _toDisplayString(_ctx.$t("modal.ConfirmDialog.buttonText")), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          "aria-hidden": "true",
          class: "fixed inset-0 transition-opacity",
          title: "overlay_for_confirm",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelDialog && _ctx.cancelDialog(...args)))
        }, [
          _hoisted_3
        ]),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_btn_close, {
              "css-class": "absolute z-20",
              onClick: _ctx.cancelDialog
            }, null, 8, ["onClick"])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("modal.ConfirmDialog.dialogTitle")), 1),
              _createVNode("div", _hoisted_10, [
                _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("modal.ConfirmDialog.dialogDescription")), 1)
              ])
            ]),
            _createVNode("div", null, [
              _createVNode(_component_rating_icons)
            ]),
            _hoisted_12,
            _createVNode("div", null, [
              _createVNode(_component_input_area, {
                "input-placeholder": _ctx.inputPlaceholder,
                "css-class": "my-2",
                "i-height": "h-40 sm:h-30",
                "i-padding": "p-4",
                "i-width": "w-full",
                "text-position": "text-left"
              }, null, 8, ["input-placeholder"])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_default_button, {
              "button-text": _ctx.$t('modal.ConfirmDialog.saveButtonText'),
              "button-color": "bg-bp",
              "button-width": "w-5/6 sm:w-auto",
              "button-x-padding": "px-1 sm:px-12",
              class: "mb-0",
              style: {"margin-block":"initial","margin-bottom":"1rem"},
              onClick: _ctx.confirm
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("modal.ConfirmDialog.saveButtonText")), 1)
              ]),
              _: 1
            }, 8, ["button-text", "onClick"]),
            _createVNode(_component_default_button, {
              "button-text": _ctx.$t('modal.ConfirmDialog.cancelButtonText'),
              "button-color": "bg-gray-200 dark:bg-gray-600",
              "button-width": "w-5/6 sm:w-auto",
              "button-x-padding": "px-1 sm:px-12",
              class: "mb-0",
              style: {"margin-block":"initial","margin-bottom":"1rem"},
              onClick: _ctx.cancelDialog
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("modal.ConfirmDialog.cancelButtonText")), 1)
              ]),
              _: 1
            }, 8, ["button-text", "onClick"])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.dialogVisible]
    ])
  ], 64))
})